import React, { useEffect, useState } from "react";
import { Modal, Input, message } from "antd";
import Button from "../components/shared/button";
import { useTranslation } from "react-i18next";
import InputField from "./../components/shared/input";
import secureLocalStorage from "react-secure-storage";
import { addFeedback } from "../APIs/feedbackApis";

const FeedbackModal = ({ isreminderModalOpen, setisreminderModalOpen }) => {
  const [activeEmoji, setActiveEmoji] = useState(null);
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const emojis = [
    {
      id: 1,
      label: "Poor!",
      color: "#F16A77",
      dullSrc: "../../assets/icons/angry-dull.svg",
      activeSrc: "../../assets/icons/angry-colored.svg",
    },
    {
      id: 2,
      label: "Good!",
      color: "#FCC378",
      dullSrc: "../../assets/icons/wink-dull.svg",
      activeSrc: "../../assets/icons/wink-colored.svg",
    },
    {
      id: 3,
      label: "V-nice!",
      color: "#FCC378",
      dullSrc: "../../assets/icons/smiling-dull.svg",
      activeSrc: "../../assets/icons/smiling-colored.svg",
    },
    {
      id: 4,
      label: "Awesome!",
      color: "#FCC378",
      dullSrc: "../../assets/icons/laughing-dull.svg",
      activeSrc: "../../assets/icons/laughing-colored.svg",
    },
  ];
  const handleOk = () => {
    setisreminderModalOpen(false);
  };

  const handleCancel = () => {
    setisreminderModalOpen(false);
  };
useEffect(() => {
  const loginData = secureLocalStorage.getItem("loginCredentials");

  setEmail(loginData.user.email);

}, []);


const handleSubmit = () => {

  if(!name ) return message.error("Please enter name") ;
  if(!description ) return message.error("Please enter description") ;

  addFeedback(name, description).then((res) => {

      message.success("Feedback submitted successfully");
      setisreminderModalOpen(false);
      setName("");
      setDescription("");

  }).catch((err) => {
    console.log(err.response.data.message);
    message.error(err.response.data.message);
    setisreminderModalOpen(false);
    setName("");
    setDescription("");

  });




}
  return (
    <>
      <Modal
        open={isreminderModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="del-modal"
        centered={true}
        width="35%"
      >
        <div className="modal-content  flex flex-col items-center py-[40px] px-[36px] max-sm:px-[20px]">
          <h5 className="text-blue font-manrope text-center font-medium max-w-[327px]">
            Feedback Donna
          </h5>
          {/* <div className="mt-[70px]">
            <p className="text-center text-[#000] font-inter large">
              How was the call quality?
            </p>
            <div className="flex items-center justify-center gap-[30px] mt-[16px]">
              {emojis.map((emoji) => (
                <div
                  key={emoji.id}
                  className="flex flex-col items-center gap-[9px]"
                >
                  <img
                    src={
                      activeEmoji === emoji.id ? emoji.activeSrc : emoji.dullSrc
                    }
                    alt={emoji.label}
                    className={`cursor-pointer w-[36px] h-[36px] transition-transform duration-300 ${
                      activeEmoji === emoji.id ? "scale-110" : "scale-100"
                    }`}
                    onClick={() => setActiveEmoji(emoji.id)}
                  />
                  <p
                    className={`font-inter small font-bold transition-opacity duration-300 ${
                      activeEmoji === emoji.id ? "opacity-100" : "opacity-0"
                    }`}
                    style={{ color: emoji.color }}
                  >
                    {emoji.label}
                  </p>
                </div>
              ))}
            </div>
          </div> */}
          <div className="flex flex-col gap-[12px] mt-[21px] w-full">
            <InputField
              label="Name"
              type="text"
              name="text"
              placeholder="Name"
              className="dash-input-field"
              wrapperClass="dash-wrapper"
              labelClass="dash-label"
              maxWidth="100%"
              onChange={(e) => setName(e.target.value)}
            />

            <InputField
              label={t("dashboard.settings.email")}
              type="text"
              name="text"
              placeholder={t("dashboard.settings.email")}
              className="dash-input-field"
              wrapperClass="dash-wrapper"
              labelClass="dash-label"
              maxWidth="100%"
              onChange={(e) => console.log(e)}
              value={email}
              disabled
            />
          </div>
          <div className="w-full mt-[12px] max-sm:flex-col">
            <p className="text-blue font-medium font-manrope medium">
              Description
            </p>
            <Input.TextArea
              placeholder="Description"
              rows={5}
              className="mt-[6px]"
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>

          <div className="mt-[50px] flex gap-[10px]">
            <Button
              text="Cancel"
              className="button btn-blue-border rounded-[39px] large"
              height={45}
              width={142}
              onClick={handleCancel}
            />
            <Button
              text="Submit"
              className="button btn-blue !rounded-[39px] large  m-auto"
              height={45}
              width={142}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default FeedbackModal;
